import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ButtonHTMLAttributes, useContext } from 'react';

import ChipContainer from './ChipContainer';
import ChipContext from './context/ChipContext';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    isSelected?: boolean;
}

function Chip(props:Props) {
    const { isSelected, ...rest } = props;
    const { variant } = useContext(ChipContext);
    if (isSelected) {
        if (variant === 'outline') {
            return (<Outline {...rest} type='button'/>);
        }
        if (variant === 'fill') {
            return (<Fill {...rest} type='button'/>);
        }
    }
    return (<Default {...rest} type='button'/>);
}

const Default = styled.button`
    padding: 0 8px;
    border-radius: 12px;
    box-shadow: 0 0 2px 2px rgba(205, 205, 205, 0.70);
    background-color: var(--color-white);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    height: 36px;
    min-height: 36px;
    color: var(--color-gray6);
`;

const Outline = styled.button`
    padding: 8px;
    border-radius: 12px;
    box-shadow: 0 0 2px 2px rgba(205, 205, 205, 0.70);
    border: 1px solid var(--color-gray2);
    background-color: var(--color-white);
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    height: 36px;
    color: var(--color-gray6);
`;

const Fill = styled.button`
    padding: 0 8px;
    border-radius: 12px;
    box-shadow: 0 0 2px 2px rgba(205, 205, 205, 0.70);
    background-color: var(--color-primary);
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    height: 36px;
    color: ${colors.buttonText};
`;

Chip.Container = ChipContainer;

export default Chip;
